import api from "api/api";

export const getDomainByIdQuery = async ({ id }) =>
  await api.get(`/datatrack/domain/${id}`);

export const getDomainListByUserIdQuery = async ({ id, userScope }) =>
  await api.get(`/datatrack/domain/user/${id}?scope=${userScope}`);

export const createDomainQuery = async (data) =>
  await api.post(`/datatrack/domain`, data);

export const updateDomainQuery = async ({ id, data }) =>
  await api.put(`/datatrack/domain/${id}`, data);

export const deleteDomainQuery = async (id) =>
  await api.delete(`/datatrack/domain/${id}`);
